<template>
	<v-container pa-0 d-flex justify-center full-width>
		<v-layout justify-center column style="max-width: 600px">
			<v-flex
				class="border-4 white--text mt-2 pa-3"
				:style="{ backgroundColor: themeInputColor }"
			>
				<div class="big-font pt-2">Account Balance</div>
				<div class="huge-font">
					<span class="bigger-font half-opacity">&#8377;</span>
					{{ jeet11WalletBalance.toLocaleString() }}
				</div>
				<div class="title pt-4">
					Pay To Selected Retailers
				</div>
				<div class="huge-font">
					<span class="bigger-font half-opacity">&#8377;</span>
					{{ amountToBePaid.toLocaleString() }}
					<v-btn
						color="green"
						:disabled="disablePayButton"
						:loading="paymentInProgress"
						small
						@click.stop="payRetailCommission"
						>PAY</v-btn
					>
					<div class="body-2">
						( {{ selectedRetailers.length }} Retailers Selected )
					</div>
				</div>
			</v-flex>
			<div>
				<div
					v-if="(retailerEntries || []).length > 0"
					class="tableContainer"
				>
					<div class="tableHeader">
						<div>
							<v-btn
								:color="themeInputColor"
								class="white--text"
								small
								@click.stop="toggleAllSelection"
								:disabled="paymentInProgress"
								>{{
									selectedRetailers.length ===
									retailerEntries.length
										? "UN"
										: ""
								}}SELECT ALL</v-btn
							>
							Retailers
						</div>
						<div>Commission</div>
					</div>
					<div
						class="bg"
						v-infinite-scroll="fetchRetailerEntries"
						infinite-scroll-disabled="disableInfiniteLoading"
						infinite-scroll-distance="200"
						infinite-scroll-throttle-delay="200"
					>
						<template v-for="(item, index) in retailerEntries">
							<div :key="index" class="listEntry">
								<div class="entryInfo">
									<div class="d-flex align-center">
										<v-checkbox
											v-model="selectedRetailers"
											:color="themeInputColor"
											class="mr-2"
											:value="index"
											@change="() => handleToggle(index)"
											:disabled="disableCheckbox(index)"
										></v-checkbox>
										<div>
											<div
												class="bigger-font blue--text text--darken-4"
											>
												{{ item.name }}
											</div>
											<div class="overline pt-1">
												{{ item.phoneNo }}
											</div>
										</div>
									</div>
									<div class="entryMoney">
										<div
											class="title light-blue--text text--darken-4"
										>
											₹{{
												item.totalCommission
													.toFixed(2)
													.toLocaleString()
											}}
										</div>
										<div
											class="caption blue-grey--text text--darken-1 pt-1"
										>
											<span
												v-if="
													item.inprocessCommission > 0
												"
												class="orange--text text--accent-4 font-weight-medium"
												>Inprocess: ₹{{
													item.inprocessCommission
														.toFixed(2)
														.toLocaleString()
												}}
												-
											</span>
											Unpaid: ₹{{
												item.unpaidCommission
													.toFixed(2)
													.toLocaleString()
											}}
										</div>
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</v-layout>
	</v-container>
</template>

<script>
import {
	COMMISSION_PAYOUT,
	FETCH_DSTR_RETAILERS_COMMISSION,
	FETCH_JEET11_PARTNER_WALLET_DETAILS
} from "../../store/action-types";
import { mapState } from "vuex";
import infiniteScroll from "vue-infinite-scroll";
import { END, TOP } from "../../store/config";
import { RUMMY_COLOUR, THEME_INPUT_COLOUR } from "../constants";

export default {
	data() {
		return {
			disableInfiniteLoading: false,
			selectedRetailers: [],
			amountToBePaid: 0,
			paymentInProgress: false
		};
	},
	directives: { infiniteScroll },
	methods: {
		fetchRetailerEntries(type = END) {
			if (!this.disableInfiniteLoading || type === TOP) {
				this.disableInfiniteLoading = true;
				this.$store
					.dispatch(FETCH_DSTR_RETAILERS_COMMISSION.dispatch, {
						type,
						isRummyOptionSelected: this.isRummyOptionSelected
					})
					.catch(() => {})
					.then(() => {
						this.disableInfiniteLoading = !this.nextOffset;
					});
			}
		},
		fetchJeet11WalletDetails() {
			this.$store
				.dispatch(FETCH_JEET11_PARTNER_WALLET_DETAILS.dispatch, {
					isSchemeRequired: true,
					isCardGame: this.isRummyOptionSelected ? 1 : 0
				})
				.catch(() => {})
				.then(() => {});
		},
		payRetailCommission() {
			this.paymentInProgress = true;
			const retailersPay = this.selectedRetailers.reduce(
				(arr, retailerIdx) => {
					arr.push({
						userId: this.retailerEntries[retailerIdx].userId,
						amount: +this.retailerEntries[retailerIdx]
							.unpaidCommission
					});
					return arr;
				},
				[]
			);
			this.$store
				.dispatch(COMMISSION_PAYOUT.dispatch, {
					retailersPay,
					isRummyOptionSelected: this.isRummyOptionSelected
				})
				.catch(() => {})
				.then(data => {
					if (data.status === "success") {
						this.fetchJeet11WalletDetails();
						this.fetchRetailerEntries(TOP);
						this.selectedRetailers = [];
						this.amountToBePaid = 0;
					}
				})
				.finally(() => {
					this.paymentInProgress = false;
				});
		},
		toggleAllSelection() {
			const areAllRetailersSelected =
				this.selectedRetailers.length === this.retailerEntries.length;
			if (areAllRetailersSelected) {
				this.selectedRetailers = [];
				this.amountToBePaid = 0;
			} else {
				let amountToBePaid = 0;
				this.selectedRetailers = this.retailerEntries.reduce(
					(arr, retailer, index) => {
						if (
							retailer.unpaidCommission > 0 &&
							amountToBePaid + retailer.unpaidCommission <=
								this.jeet11WalletBalance
						) {
							amountToBePaid += retailer.unpaidCommission;
							arr.push(index);
						}
						return arr;
					},
					[]
				);
				this.amountToBePaid = amountToBePaid;
			}
		},
		handleToggle(index) {
			const selected = this.selectedRetailers.includes(index);
			this.amountToBePaid +=
				(selected ? 1 : -1) *
				this.retailerEntries[index].unpaidCommission;
		},
		disableCheckbox(index) {
			const hasEnoughWalletBalance =
				this.amountToBePaid +
					this.retailerEntries[index].unpaidCommission >
				this.jeet11WalletBalance;
			return (
				(hasEnoughWalletBalance &&
					!this.selectedRetailers.includes(index)) ||
				!this.retailerEntries[index].unpaidCommission ||
				this.paymentInProgress
			);
		}
	},
	props: ["isRummyOptionSelected"],
	mounted() {
		// this.fetchJeet11WalletDetails();
		// this.fetchRetailerEntries(TOP);
	},
	computed: {
		...mapState({
			jeet11WalletBalance: state =>
				state.jeet11.jeet11PartnerDetails.walletBalance || 0,
			retailerEntries: state =>
				state.jeet11.distributorCommission.retailerEntries,
			nextOffset: state => state.jeet11.distributorCommission.nextOffset
		}),
		themeInputColor() {
			return this.isRummyOptionSelected
				? RUMMY_COLOUR
				: THEME_INPUT_COLOUR;
		},
		disablePayButton() {
			return (
				this.amountToBePaid > this.jeet11WalletBalance ||
				this.amountToBePaid === 0
			);
		}
	}
};
</script>

<style scoped lang="scss">
.tableContainer {
	box-shadow: 0px 0px 8px rgba(7, 28, 80, 0.1);
}
.tableHeader {
	background: #edf0f7;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 2px 16px 2px 2px;
	font-size: 12px;
	color: #7b899e;
	margin-top: 3em;
}
.listEntry {
	display: flex;
	align-items: center;
	padding: 12px 8px 14px;
	border-bottom: 1px solid #ccc;
	position: relative;
}
.entryInfo {
	flex: 0 1 calc(100%);
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-inline: 5px;
	& > div:first-child > div:first-child {
		color: #575f6b;
		font-size: 14px;
	}
	& > div:first-child > div:last-child {
		color: #828a97;
		font-size: 12px;
	}
}
.entryMoney {
	font-size: 12px;
	display: flex;
	flex-direction: column;
	justify-content: right;
	direction: rtl;
	overflow-wrap: anywhere;
}
.big-font {
	font-size: 14px;
	font-weight: 500;
}
.bigger-font {
	font-size: 24px;
	font-weight: 500;
}
.huge-font {
	font-size: 30px;
	font-weight: 500;
}
.border-4 {
	border-radius: 4px;
}
.half-opacity {
	opacity: 0.6;
}
</style>
